export const DisclaimerLinks = {
    PrivacyPolicy: "https://www.snap.com/en-US/privacy/privacy-policy/",
    LensStudioTerms: "https://www.snap.com/en-US/terms/lens-studio-terms",
    AdsTerms: "https://businesshelp.snapchat.com/en-US/a/self-serve-ad-terms",
    TermsofService: "https://www.snap.com/en-US/terms",
};
